<template>
<v-card :flat='flat'>
  <v-snackbar v-model='successsnacker' ></v-snackbar>
  <v-card-text class='pa-0' >
    <v-btn
      @click='editmode="add";setBlankSelectedRow();addedit = true;'
      absolute dark fab top right small class="blue" >
      <v-icon>add</v-icon>
    </v-btn>
    <slot name='before-table' :selected="selected" ></slot>
    <v-data-table dense
      :loading='loading'
      :headers="tableHeaders"
      :items="tableItems"
      :hide-actions="true"
      :class="{'dense': dense}"
      :disable-initial-sort='true' >

      <template slot="headers" slot-scope="props">
        <tr class='grey lighten-2'>
          <th v-if="selectable" style='max-width:5px;' >
            <v-checkbox v-model="selectAll" class="mt-4" />
          </th>
          <th style='max-width:50px;' v-if='withExpand' >&nbsp</th>
          <th v-for="header in props.headers" :key="header.text"
            style='text-align:left;'
            class='overline' >
            <slot :name="`header-${header.value}`" >{{ header.text }}</slot>
          </th>
          <th style='max-width:50px;' >&nbsp</th>
        </tr>
        <v-divider />
      </template>

      <template slot="items" slot-scope="props">
        <tr
          @click='editmode="edit";selectedRow=props.item;addedit=true'
          :class='{"archived": props.item.archived}' >

          <td style='max-width:50px;' v-if='withExpand' >
            <v-btn small flat icon
              @click.stop="props.expanded = !props.expanded" >
              <v-icon v-if='!props.expanded' >expand_more</v-icon>
              <v-icon v-else >expand_less</v-icon>
            </v-btn>
          </td>

          <td v-if="selectable">
            <div @click.stop="noop" >
            <v-checkbox small
              v-model="selected"
              :value="props.item" />
            </div>
          </td>

          <td v-for='header in tableHeaders' :key='header.value' >
            <slot
              :name='header.value'
              :value='props.item[header.value]'
              :item='props.item' >
              <template v-if='header.component === "vcheckbox"' >
                <v-icon small v-if='props.item[header.value]' >check_box</v-icon>
                <v-icon small v-else >check_box_outline_blank</v-icon>
              </template>
              <span v-else >{{ props.item[header.value] }}</span>
            </slot>
          </td>
          <!-- <td v-if='deleteable' class="text-xs-right">
            <v-btn icon
              :disabled="!props.item.id"
              @click.stop='confirmDelete=true;selectedRow=props.item;selectedIndex=props.index'>
              <v-icon>{{deleteIcon}}</v-icon>
            </v-btn>
          </td> -->
          <td class="text-xs-right">
            <v-btn small icon outline outlined >
              <v-icon small >edit</v-icon>
            </v-btn>
            <v-btn small icon outline outlined
              v-if="withInlineDelete"
              color="error"
              @click.stop='selectedRow=props.item;confirmDelete=true' >
              <v-icon small >delete</v-icon>
            </v-btn>
          </td>
        </tr>
        <tr v-if='props.item.loading' >
          <td colspan='100%' style='padding:0px;height:4px;' >
          <v-progress-linear style='margin:0px;padding:0px;' :height='3' v-bind:indeterminate="true"></v-progress-linear>
          </td>
        </tr>
      </template>
      <template slot="expand" slot-scope="props">
        <slot name="expand" :item='props.item' >
        </slot>
      </template>
      <template slot="no-data" >
        <div v-if='!loading' class='text-xs-center'>
          {{noDataText}}
          <v-btn @click='editmode="add";setBlankSelectedRow();addedit = true;' flat >
            {{ emptyBtnText }}</v-btn>
        </div>
        <div v-else class='text-xs-center'>
          <v-progress-circular color='amber' width='1' size='14' class='mr-1' indeterminate ></v-progress-circular> loading
        </div>
      </template>
    </v-data-table>

    <v-dialog v-model="confirmDelete" :max-width="(dialogWidth - 30)">
      <v-card>
        <v-card-title class='subheading py-0'>
            {{confirmDeleteTitle}}
            <v-spacer></v-spacer>
            <v-btn icon @click='confirmDelete=false' ><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-alert absolute dismissible
          v-if='successsnacker && deleteRequestStatus === 204'
          transition="slide-y-transition"
          class='ma-0 absolute-top'  type='success'
          :value='true' >
            Your changes have been saved
        </v-alert>
        <v-card-text>
          <v-alert type='info' v-if='confirmDeleteTagline' :value='true' dense class='subheading' >
            {{confirmDeleteTagline}}
          </v-alert>
          <v-list dense>
            <template v-for='(header, index) in headers' >
              <v-list-tile :key='header.index' >
                <v-list-tile-content >
                  <v-list-tile-title>{{selectedRow[header.value]}}</v-list-tile-title>
                  <v-list-tile-sub-title>{{header.value}}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider :key='index' ></v-divider>
            </template>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-btn @click='confirmDelete=false' flat>Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn @click='deleteRow' :loading='loading' color='error' >{{deleteText}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="addedit" :max-width="dialogWidth">
      <v-form v-model='isValid' ref='form' >
      <v-card>
        <v-navigation-drawer v-if='withInlineHelp' permanent absolute right :value='true' >
          Help information will show here
        </v-navigation-drawer>
        <v-card-title
          class="subheading py-0 grey lighten-4">
          <span v-if='editmode=="edit"' >Edit</span>
          <span v-else >Add</span>
          <v-spacer></v-spacer>
          <v-btn @click='$emit("crud:adddialogclosed");addedit=false' icon><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-alert
          v-if='editRequestStatus === 400 || createRequestStatus === 0'
          transition="slide-y-transition"
          class='ma-0 absolute-top' absolute dismissible type='warning' :value='true' >
            Some information you entered was invalid. Please check below and resubmit
        </v-alert>
        <v-alert absolute dismissible
          v-if='successsnacker && (editRequestStatus === 200 || createRequestStatus === 201)'
          transition="slide-y-transition"
          class='ma-0 absolute-top'  type='success'
          :value='true' >
            Your changes have been saved
        </v-alert>
        <slot name='addedit-cardtext-outer' ></slot>
        <v-card-text>
          <v-layout row wrap >
          <slot name='dialog-header' ></slot>
          <template v-for='(header, key) in headers' >
              <slot
              :name='"field-" + header.value'
              :header='header' :selectedRow='selectedRow' >
              <v-flex
                class='px-2'
                v-bind='header.flex'
                :xs12='!header.flex' >
                <v-checkbox v-if='header.component === "vcheckbox"'
                  v-model='selectedRow[header.value]'
                  style='width:100%;'
                  :error-messages='getErrors(header.value)'
                  :hint='header.hint'
                  :label='header.text'
                  :prefix='header.prefix'
                  :suffix='header.suffix'
                  :required='header.required'
                  :rules='header.rules || []'
                  :type='header.type || "text"'
                  persistent-hint
                  class='mb-3' >
                </v-checkbox>
                <v-divider v-else-if='header.component === "vdivider"' class='my-3' />
                <v-select v-else-if='header.component === "vselect"'
                  v-model='selectedRow[header.value]'
                  style='width:100%;'
                  v-bind='header.attrs'
                  :error-messages='getErrors(header.value)'
                  :hint='header.hint'
                  :label='header.text'
                  :prefix='header.prefix'
                  :suffix='header.suffix'
                  :required='header.required'
                  :rules='header.rules || []'
                  persistent-hint
                  class='mb-3' >
                </v-select>
                <component
                  v-else-if='header.component'
                  v-bind='header.attrs'
                  v-model='selectedRow[header.value]'
                  :error-messages='getErrors(header.value)'
                  :is="header.component" >

                </component>
                <v-text-field
                  v-else
                  :outline='getErrors(header.value).length > 0'
                  :error-messages='getErrors(header.value)'
                  :hint='header.hint'
                  :label='header.text'
                  :prefix='header.prefix'
                  :suffix='header.suffix'
                  :required='header.required'
                  :rules='header.rules || []'
                  :type='header.type || "text"'
                  v-bind='header.attrs'
                  v-model='selectedRow[header.value]' >
                </v-text-field>
              </v-flex>
              </slot>
          </template>
          </v-layout>
        </v-card-text>

        <v-card-actions absolute v-if='editmode==="edit"' >
          <v-btn
            :disabled="!selectedRow.id"
            color='error' @click='confirmDelete=true' >{{deleteText}}</v-btn>
          <v-spacer></v-spacer>
          <v-btn :loading='loading'
            v-if='editmode==="edit"'
            @click='addedit=false' flat text >Done</v-btn>
          <v-btn :loading='loading'
            v-if='editmode==="edit"'
            @click='editRow' color='primary' >Save</v-btn>
        </v-card-actions>
        <v-card-actions v-else >
          <v-btn @click='addedit=false' flat >Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn :loading='loading' @click='addRow(true)' color='primary' dark >Add</v-btn>
          <v-btn v-if='closeOnEdit' :loading='loading' @click='addRow(false)' color='primary' dark >Add & add more</v-btn>
        </v-card-actions>
      </v-card>
      </v-form>
    </v-dialog>
  </v-card-text>
</v-card>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'CrudTable',
  props: {
    loading: { type: Boolean, default: false },
    deleteable: { type: Boolean, default: true },
    withInlineDelete: { type: Boolean, default: false },
    flat: { type: Boolean, default: false },
    dense: { type: Boolean, default: false },
    waitForServer: { type: Boolean, default: false },
    closeOnEdit: { type: Boolean, default: true },
    deleteReqId: { type: String, required: false },
    editReqId: { type: String, required: false },
    createReqId: { type: String, required: false },
    noDataText: { type: String, default: 'No items found' },
    headers: { type: Array, default: () => { return [] } },
    dialogWidth: { type: Number, default: 400 },
    items: { type: Array, default: () => { return [] } },
    ignoredFields: { type: Array, default: () => { return ['del'] } },
    selectable: { type: Boolean, default: false },
    withExpand: { type: Boolean, default: false },
    withInlineHelp: { type: Boolean, default: false },
    emptyBtnText: { type: String, default: 'Add new record' },
    confirmDeleteTitle: { type: String, default: 'Are you sure?' },
    confirmDeleteTagline: { type: String, default: 'Are you sure you want to delete this row?' },
    deleteIcon: { type: String, default: 'delete' },
    deleteText: { type: String, default: 'Delete' }
  },
  computed: {
    tableHeaders () {
      return this.headers.filter((header) => {
        return (header.displayInTable !== false)
      })
    },
    editRequest () {
      return this.$store.getters.getRequestById(this.editReqId, true)
    },
    editRequestStatus () {
      return this.editRequest.status
    },
    createRequest () {
      return this.$store.getters.getRequestById(this.createReqId, true)
    },
    createRequestStatus () {
      return this.createRequest.status
    },
    deleteRequest () {
      return this.$store.getters.getRequestById(this.deleteReqId, true)
    },
    deleteRequestStatus () {
      return this.deleteRequest.status
    },
    errors () {
      if (this.editRequestStatus === 400 || this.createRequestStatus === 400) {
        return this.getObjectPath(this.editRequest, 'result.data', {})
      }
      return {}
    }
  },
  methods: {
    getErrors (field) {
      if (this.errors && this.errors[field]) { return this.errors[field] }
      return []
    },
    setBlankSelectedRow () {
      this.selectedRow = {}
      if (this.headers) {
        for (let field of this.headers) {
          if (this.ignoredFields.indexOf(field.value) === -1) {
            Vue.set(this.selectedRow, field.value, '') // set row to blank
          }
        }
      }
    },
    addRow (withClose) {
      this.$emit('add', this.selectedRow)
      this.items.push(this.selectedRow)
      if (withClose) {
        if (!this.waitForServer) {
          this.addedit = false
          this.$emit('crud:adddialogclosed')
        }
      } else {
        // copy the old values:
        let oldSelectedRow = JSON.parse(JSON.stringify(this.selectedRow))
        this.setBlankSelectedRow()
        if (this.headers) {
          for (let field of this.headers) {
            if (this.ignoredFields.indexOf(field.value) === -1) {
              // set row back to old value:
              Vue.set(this.selectedRow, field.value, oldSelectedRow[field.value])
            }
          }
        }
      }
    },
    editRow () {
      if (this.closeOnEdit) {
        this.addedit = false // close the dialog
      }
      this.$emit('edit', this.selectedRow)
    },
    deleteRow () {
      // deleteRow();
      // this.items.splice(this.selectedIndex, 1)
      this.$emit('delete', this.selectedRow)
      if (!this.waitForServer) {
        this.confirmDelete = false
        this.addedit = false
      }
    },
    noop () { }
  },
  mounted () {
    this.tableItems = this.items
    if (this.waitForServer === true) {
      if (!this.editReqId || !this.createReqId || !this.deleteReqId) {
        console.error('WaitforServer is true. But one of editReqId, createReqId or deleteReqId is missing')
        console.log('edit', this.editReqId)
        console.log('create', this.createReqId)
        console.log('create', this.deleteReqId)
      }
    }
  },
  watch: {
    tableItems () {
      this.$emit('input', this.tableItems)
    },
    items () {
      if (this.items) {
        this.tableItems = this.items
      }
    },
    selectAll () {
      console.log(this.tableItems)
      if (this.selectAll === true) {
        this.selected = this.tableItems
      } else {
        this.selected = []
      }
    },
    editRequestStatus () {
      if (this.editRequestStatus === 200) {
        this.successsnacker = true
        let vm = this
        window.setTimeout(() => { vm.successsnacker = false }, 2000)
      }
    },
    createRequestStatus () {
      if (this.editRequestStatus === 201) {
        this.successsnacker = true
        let vm = this
        window.setTimeout(() => {
          vm.successsnacker = false
          vm.addedit = false // close the dialog
        }, 2000)
      }
    },
    deleteRequestStatus () {
      if (this.editRequestStatus === 204) {
        this.successsnacker = true
        let vm = this
        window.setTimeout(() => {
          vm.successsnacker = false
          vm.confirmDelete = false
          vm.addedit = false
        }, 2000)
      }
    }
  },
  data () {
    return {
      selectAll: false,
      successsnacker: false,
      isValid: false,
      tableItems: [],
      addedit: false,
      confirmDelete: false,
      editmode: 'add', // edit
      selectedRow: [],
      selected: [],
      selectedIndex: 0
    }
  }
}
</script>

<style scoped>
.absolute-top {
  position:absolute;top:0;left:0;right:0
}
tr.archived { background-color: #f1f1f1; color: grey }

.dense table.v-table tbody td { height: auto !important;}
.dense table.v-table thead tr { height: auto !important;}

</style>



// WEBPACK FOOTER //
// CrudTable.vue?cd42ece6